import React, { useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import ImageCrop from './adjustImage'
import { styles } from './styles'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import CHRButton from './../button'
import CHROutlinedButton from './../outlinedButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'

interface ImageDialogProps {
  openStatus: boolean
  selectedImage: any
  cropCallback: Function
  onCancel: Function
  t: TFunction
}

const ImageDialog = ({
  t,
  openStatus,
  selectedImage,
  cropCallback,
  onCancel,
}: ImageDialogProps) => {
  const classes = styles()
  const [editor, setEditor] = useState(React.createRef())
  const [scaleValue, setScaleValue] = useState(1)
  const [position, setPosition] = useState({ x: 0, y: 0 })

  const onScaleChange = (event: any, scaleValue: number | number[]) => {
    setScaleValue(scaleValue)
  }

  const onCrop = () => {
    const url = editor.current.getImageScaledToCanvas().toDataURL()
    cropCallback(url)
  }

  const resetAdjustments = () => {
    setScaleValue(1)
    setPosition({ x: 0, y: 0 })
  }

  const onPositionChange = (coordinatesObj: { y: number; x: number }) => {
    setPosition(coordinatesObj)
  }

  return (
    <Dialog
      open={openStatus}
      aria-labelledby="responsive-dialog-title"
      className={classes.dialogContainer}
    >
      <Typography
        variant="h2"
        align="center"
        className={classes.uploadPicTitle}
      >
        {t('dashboard.uploadYourPic')}
      </Typography>
      <CloseIcon
        className={classes.closeIcon}
        onClick={onCancel}
        color="primary"
      />
      <DialogContent className={classes.dialogContent}>
        <ImageCrop
          imageSrc={selectedImage}
          editorRef={editor}
          scaleValue={scaleValue}
          onScaleChange={onScaleChange}
          position={position}
          onPositionChange={onPositionChange}
          resetAdjustments={resetAdjustments}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <CHRButton onClick={onCrop} label={t('dashboard.uploadImage')} />
      </DialogActions>
    </Dialog>
  )
}

export default withTranslation()(ImageDialog)
